import React from 'react';
import { Dropdown, DropdownProps } from 'ui-builder';

export default function NumberDropdown(props: DropdownProps) {
  const onChangeCallback = (event: any) => {
    const rawValue = event[props.source];
    props.onChangeCallback!({
      [props.source]: rawValue === '' ? undefined : parseInt(rawValue, 10),
    });
  };
  return (
    <Dropdown
      {...props}
      onChangeCallback={onChangeCallback}
    />
  );
}
